import { render, staticRenderFns } from "./FormAcceloCustomField.vue?vue&type=template&id=06c5ba53&"
import script from "./FormAcceloCustomField.vue?vue&type=script&lang=js&"
export * from "./FormAcceloCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports